<div class="osmos-editor" [class.osmos-editor--bare]="toolbar === 'none'">
  <osmos-editor-toolbar *ngIf="toolbar === 'full' && editor" [editor]="editor"></osmos-editor-toolbar>
  <div #content class="osmos-editor__content rt-content" [attr.data-placeholder]="placeholder"></div>
</div>
